var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 35,
    viewBox: "0 0 64 64",
    width: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#008eff",
    height: 34,
    rx: 1,
    width: 14,
    x: 45,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#008eff",
    height: 6,
    rx: 1,
    width: 6,
    x: 50,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#008eff",
    height: 6,
    rx: 1,
    width: 6,
    x: 50,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#008eff",
    height: 34,
    rx: 1,
    width: 14,
    x: 5,
    y: 28
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#008eff",
    height: 6,
    rx: 1,
    width: 6,
    x: 8,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#008eff",
    height: 6,
    rx: 1,
    width: 6,
    x: 8,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#008eff",
    height: 45,
    rx: 1,
    width: 30,
    x: 17,
    y: 17
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9fe0f6"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 1,
    width: 6,
    x: 20,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 1,
    width: 6,
    x: 29,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 1,
    width: 6,
    x: 38,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 1,
    width: 6,
    x: 20,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 1,
    width: 6,
    x: 29,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 1,
    width: 6,
    x: 38,
    y: 29
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 1,
    width: 6,
    x: 20,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 1,
    width: 6,
    x: 29,
    y: 37
  }), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    rx: 1,
    width: 6,
    x: 38,
    y: 37
  })), /*#__PURE__*/React.createElement("path", {
    d: "m40 47h-16a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2z",
    fill: "#008eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 46h12v15h-12z",
    fill: "#9fe0f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 45h-12a1 1 0 0 0 -1 1v15a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-15a1 1 0 0 0 -1-1zm-11 2h4v13h-4zm10 13h-4v-13h4z",
    fill: "#008eff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 62h-58a1 1 0 0 1 0-2h58a1 1 0 0 1 0 2z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.11 14.578a1.007 1.007 0 0 1 -.351-.064 7.847 7.847 0 0 0 -5.518 0 1 1 0 0 1 -.7-1.873 9.855 9.855 0 0 1 6.922 0 1 1 0 0 1 -.351 1.937z",
    fill: "#f15a24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.979 10.477a1 1 0 0 1 -.459-.112 12 12 0 0 0 -11.04 0 1 1 0 1 1 -.92-1.775 14 14 0 0 1 12.88 0 1 1 0 0 1 -.461 1.887z",
    fill: "#f7931e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.789 6.468a1 1 0 0 1 -.518-.145 15.892 15.892 0 0 0 -16.542 0 1 1 0 0 1 -1.038-1.71 17.888 17.888 0 0 1 18.618 0 1 1 0 0 1 -.52 1.855z",
    fill: "#f15a24"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.ac633d27fa3e7a0ae316ab9a779ed02b.svg";
export { ForwardRef as ReactComponent };